import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { AppShellPage } from './pages/app-shell/app-shell.page';
import { CampaignsPage } from './pages/campaigns/campaigns.page';
import { ContactsPage } from './pages/contacts/contacts.page';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { LoginPage } from './pages/login/login.page';
import { MetaCallbackPage } from './pages/meta-callback/meta-callback.page';
import { RegisterPage } from './pages/register/register.page';
import { SetupWizardPage } from './pages/setup-wizard/setup-wizard.page';
import { TemplatesPage } from './pages/templates/templates.page';

const routes: Routes = [
  {
    path: 'auth/login',
    component: LoginPage,
  },
  {
    path: 'auth/register',
    component: RegisterPage,
  },
  {
    path: 'auth/meta-callback',
    component: MetaCallbackPage,
  },
  {
    path: 'app',
    component: AppShellPage,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardPage,
      },
      {
        path: 'setup',
        component: SetupWizardPage,
      },
      {
        path: 'contacts',
        component: ContactsPage,
      },
      {
        path: 'templates',
        component: TemplatesPage,
      },
      {
        path: 'campaigns',
        component: CampaignsPage,
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
    ],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
